export default {
  SET_AUTH(state, auth) {
    state.haveAccess = auth.hasAccess;
    state.access_token = auth.access_token;
    state.accessTokenExpDate = auth.accessTokenExpDate;
  },
  DESTROY_AUTH(state) {
    state.user_info = {};
    state.access_token = null;
    state.accessTokenExpDate = null;
    state.haveAccess = false;
    state.roles = [];
  },
  SET_ATOKEN_EXP_DATE(state, expDate) {
    state.accessTokenExpDate = expDate;
  },
  SET_ROLES(state, roles) {
    state.roles = roles;
  },
  DESTROY_ROLES(state) {
    state.roles = [];
  },
  SET_USER_INFO(state, userInfo) {
    state.user_info = userInfo;
  }
};
